import { useState, useEffect } from 'react';

export const useSdkLoader = (sdkUrl) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!sdkUrl) return;
        
        if (typeof window._livenessSDK !== 'undefined') {
            setLoaded(true);
            return;
        }

        const script = document.createElement('script');
        script.src = sdkUrl;
        script.async = true;
        
        script.onload = () => {
            if (window.OzLiveness) {
                window._livenessSDK = window.OzLiveness;
            }
            setLoaded(true);
        };
        script.onerror = () => setError('Failed to load SDK');
        
        document.head.appendChild(script);

        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, [sdkUrl]);

    return { loaded, error };
};
